import { render, staticRenderFns } from "./RssViewer.vue?vue&type=template&id=42bd6a8e&scoped=true&"
import script from "./RssViewer.vue?vue&type=script&lang=js&"
export * from "./RssViewer.vue?vue&type=script&lang=js&"
import style0 from "./RssViewer.vue?vue&type=style&index=0&id=42bd6a8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd6a8e",
  null
  
)

export default component.exports